// extracted by mini-css-extract-plugin
export default {"sidebar":"style_sidebar__xfcob","shadow":"style_shadow__PEicb","sidebarHiddenIcon":"style_sidebarHiddenIcon__H0u5J"};